// Diamond shape placeholder images mapping
// Uses Azure Blob Storage stock diamond shape images
const BLOB_BASE_URL = 'https://blobaneesh.blob.core.windows.net/images/stock';
export const DIAMOND_SHAPE_IMAGES = {
    // Round/Brilliant
    'Round Brilliant': `${BLOB_BASE_URL}/round.jpg`,
    'BR': `${BLOB_BASE_URL}/round.jpg`,
    // Princess
    'Princess': `${BLOB_BASE_URL}/princess.jpg`,
    'PR': `${BLOB_BASE_URL}/princess.jpg`,
    // Emerald Cut
    'Emerald Cut': `${BLOB_BASE_URL}/emerald.jpg`,
    'EC': `${BLOB_BASE_URL}/emerald.jpg`,
    // Cushion
    'Cushion': `${BLOB_BASE_URL}/cushion.jpg`,
    'CU': `${BLOB_BASE_URL}/cushion.jpg`,
    // Oval
    'Oval': `${BLOB_BASE_URL}/oval.jpg`,
    'OV': `${BLOB_BASE_URL}/oval.jpg`,
    // Radiant
    'Radiant': `${BLOB_BASE_URL}/radiant.jpg`,
    'RAD': `${BLOB_BASE_URL}/radiant.jpg`,
    // Pear Shaped
    'Pear Shaped': `${BLOB_BASE_URL}/pear.jpg`,
    'PS': `${BLOB_BASE_URL}/pear.jpg`,
    // Marquise (using round as fallback - TODO: upload marquise.jpg to blob storage)
    'Marquise': `${BLOB_BASE_URL}/round.jpg`,
    'MQ': `${BLOB_BASE_URL}/round.jpg`,
    // Heart Shaped
    'Heart Shaped': `${BLOB_BASE_URL}/heart.jpg`,
    'HS': `${BLOB_BASE_URL}/heart.jpg`,
    // Asscher
    'Asscher': `${BLOB_BASE_URL}/asscher.jpg`,
    'AS': `${BLOB_BASE_URL}/asscher.jpg`,
    // Trillion
    'Trillion': `${BLOB_BASE_URL}/trillion.jpg`,
    'TR': `${BLOB_BASE_URL}/trillion.jpg`,
    // Default fallback (using round)
    'default': `${BLOB_BASE_URL}/round.jpg`
};
/**
 * Get diamond shape image URL
 * @param shape - Diamond shape (full name or code)
 * @param shapeCode - Optional shape code (BR, PS, etc.)
 * @returns Image URL for the diamond shape
 */
export function getDiamondShapeImage(shape, shapeCode) {
    if (!shape && !shapeCode) {
        return DIAMOND_SHAPE_IMAGES.default;
    }
    // Try shape code first
    if (shapeCode && DIAMOND_SHAPE_IMAGES[shapeCode]) {
        return DIAMOND_SHAPE_IMAGES[shapeCode];
    }
    // Try full shape name
    if (shape && DIAMOND_SHAPE_IMAGES[shape]) {
        return DIAMOND_SHAPE_IMAGES[shape];
    }
    // Try normalizing the shape name (handle variations)
    if (shape) {
        const normalized = shape.toLowerCase().trim();
        // Map common variations
        if (normalized.includes('round') || normalized.includes('brilliant')) {
            return DIAMOND_SHAPE_IMAGES['BR'];
        }
        if (normalized.includes('princess')) {
            return DIAMOND_SHAPE_IMAGES['PR'];
        }
        if (normalized.includes('emerald')) {
            return DIAMOND_SHAPE_IMAGES['EC'];
        }
        if (normalized.includes('cushion')) {
            return DIAMOND_SHAPE_IMAGES['CU'];
        }
        if (normalized.includes('oval')) {
            return DIAMOND_SHAPE_IMAGES['OV'];
        }
        if (normalized.includes('radiant')) {
            return DIAMOND_SHAPE_IMAGES['RAD'];
        }
        if (normalized.includes('pear')) {
            return DIAMOND_SHAPE_IMAGES['PS'];
        }
        if (normalized.includes('marquise')) {
            return DIAMOND_SHAPE_IMAGES['MQ'];
        }
        if (normalized.includes('heart')) {
            return DIAMOND_SHAPE_IMAGES['HS'];
        }
        if (normalized.includes('asscher')) {
            return DIAMOND_SHAPE_IMAGES['AS'];
        }
        if (normalized.includes('trillion')) {
            return DIAMOND_SHAPE_IMAGES['TR'];
        }
    }
    // Fallback to default
    return DIAMOND_SHAPE_IMAGES.default;
}
/**
 * Create inline SVG diamond icon for a given shape
 * @param shapeCode - Diamond shape code
 * @returns SVG string
 */
export function getDiamondShapeSVG(shapeCode) {
    // Simple diamond SVG shapes
    const svgShapes = {
        'BR': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" fill="currentColor" opacity="0.1"/>
      <path d="M50,10 L70,30 L60,70 L50,90 L40,70 L30,30 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'PR': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="15" width="70" height="70" fill="currentColor" opacity="0.1"/>
      <path d="M50,15 L85,50 L50,85 L15,50 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'EC': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="15" width="60" height="70" rx="5" fill="currentColor" opacity="0.1"/>
      <path d="M25,20 L75,20 L75,80 L25,80 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'OV': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="50" cy="50" rx="30" ry="45" fill="currentColor" opacity="0.1"/>
      <path d="M50,10 L65,25 L65,75 L50,90 L35,75 L35,25 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'CU': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="15" width="70" height="70" rx="10" fill="currentColor" opacity="0.1"/>
      <path d="M25,25 L75,25 L75,75 L25,75 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'PS': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M50,10 L70,40 L50,90 L30,40 Z" fill="currentColor" opacity="0.1"/>
      <path d="M50,15 L65,40 L50,85 L35,40 Z" fill="currentColor" opacity="0.3"/>
    </svg>`,
        'default': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M50,10 L80,40 L60,90 L40,90 L20,40 Z" fill="currentColor" opacity="0.2"/>
    </svg>`
    };
    return svgShapes[shapeCode || 'default'] || svgShapes.default;
}
